/* Halloween sale ("Emper After Dark"): countdowns, reveals, rails, add-to-cart and every room of the haunted house. */
(() => {
  const html = document.documentElement;
  html.classList.add('hw-js', 'hw-ready');

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pick = (list) => list[Math.floor(Math.random() * list.length)];
  const rand = (a, b) => a + Math.random() * (b - a);
  const pad = (n) => String(n).padStart(2, '0');
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  /* ---------- Dates: in the time zone set on the hero (data-tz), US Eastern daylight time if none ---------- */

  const saleEl = () => document.querySelector('[data-hw-sale]');
  const zone = () => {
    const el = saleEl();
    const tz = el && el.dataset.tz;
    return tz && /^[+-]\d{2}:\d{2}$/.test(tz) ? tz : '-04:00';
  };
  const DEFAULT_START = Date.parse('2026-10-21T00:00:00-04:00');
  const DEFAULT_END = Date.parse('2026-10-31T23:59:00-04:00');

  // "2026-10-21 00:00" (in the hero's time zone unless an offset is given) → timestamp
  const parseDate = (text, fallback) => {
    let iso = (text || '').trim().replace(' ', 'T');
    if (!iso) return fallback;
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) iso += 'T00:00';
    if (/T\d{2}:\d{2}$/.test(iso)) iso += ':00';
    if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(iso)) iso += zone();
    const time = Date.parse(iso);
    return Number.isNaN(time) ? fallback : time;
  };
  const saleWindow = () => {
    const el = saleEl();
    return { start: parseDate(el && el.dataset.start, DEFAULT_START), end: parseDate(el && el.dataset.end, DEFAULT_END) };
  };

  /* ---------- Countdowns (every one on the page, one timer) ---------- */

  const LABELS = { before: 'Sale starts in', live: 'Sale ends in', ended: 'The Halloween sale has ended' };

  function tickCountdowns() {
    const { start, end } = saleWindow();
    const now = Date.now();
    const state = now < start ? 'before' : now < end ? 'live' : 'ended';
    const left = Math.max(0, Math.floor(((state === 'before' ? start : end) - now) / 1000));
    const parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
    document.querySelectorAll('[data-hw-countdown]').forEach((count) => {
      count.classList.toggle('is-ended', state === 'ended');
      const label = count.querySelector('[data-hw-count-label]');
      const text = count.dataset[`label${state[0].toUpperCase()}${state.slice(1)}`] || LABELS[state];
      if (label && label.textContent !== text) label.textContent = text;
      const compact = count.classList.contains('hw-count--compact');
      Object.entries(parts).forEach(([unit, value]) => {
        const el = count.querySelector(`[data-u="${unit}"]`);
        const t = pad(value);
        if (!el || el.textContent === t) return;
        el.textContent = t;
        if (!reduced && !compact && unit === 's') {
          el.classList.remove('is-tick');
          void el.offsetWidth;
          el.classList.add('is-tick');
        }
      });
    });
  }

  /* ---------- Money: the store's currency, in whole units ---------- */

  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  let moneyFormat = null;
  try {
    moneyFormat = new Intl.NumberFormat(html.lang || 'en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (error) {
    moneyFormat = null;
  }
  const money = (cents) => (moneyFormat ? moneyFormat.format(Math.round(cents / 100)) : `$${Math.round(cents / 100)}`);

  /* ---------- Bursts: candy-colored confetti and sparks from one page-wide canvas ---------- */

  const HUES = {
    pumpkin: [22, 100, 56],
    candle: [40, 100, 76],
    slime: [88, 100, 64],
    bone: [40, 60, 92],
    violet: [272, 85, 70],
    blood: [350, 80, 52]
  };
  let burstCanvas = null;
  let burstCtx = null;
  let particles = [];
  let running = false;
  const ensureCanvas = () => {
    if (burstCanvas) return;
    burstCanvas = document.createElement('canvas');
    burstCanvas.setAttribute('aria-hidden', 'true');
    burstCanvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000;';
    document.body.appendChild(burstCanvas);
    burstCtx = burstCanvas.getContext('2d');
    const size = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      burstCanvas.width = window.innerWidth * dpr;
      burstCanvas.height = window.innerHeight * dpr;
      burstCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    size();
    window.addEventListener('resize', size, { passive: true });
  };
  const frame = (now) => {
    const dt = Math.min(0.05, (now - (frame.last || now)) / 1000);
    frame.last = now;
    burstCtx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    particles = particles.filter((p) => {
      p.life += dt;
      if (p.life > p.max) return false;
      p.vy += p.g * dt;
      p.vx *= 0.985;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.spin * dt;
      const k = 1 - p.life / p.max;
      const [h, s, l] = p.color;
      burstCtx.globalAlpha = Math.min(1, k * 1.8);
      burstCtx.fillStyle = `hsl(${h} ${s}% ${l}%)`;
      burstCtx.save();
      burstCtx.translate(p.x, p.y);
      burstCtx.rotate(p.rot);
      if (p.shape === 'corn') {
        // a tiny candy corn: white tip, orange middle, yellow base
        burstCtx.fillStyle = '#fff6e0';
        burstCtx.beginPath();
        burstCtx.moveTo(0, -p.size * 1.3);
        burstCtx.lineTo(p.size * 0.35, -p.size * 0.6);
        burstCtx.lineTo(-p.size * 0.35, -p.size * 0.6);
        burstCtx.fill();
        burstCtx.fillStyle = '#ff7a1a';
        burstCtx.fillRect(-p.size * 0.6, -p.size * 0.6, p.size * 1.2, p.size * 0.7);
        burstCtx.fillStyle = '#ffcf33';
        burstCtx.fillRect(-p.size * 0.8, p.size * 0.1, p.size * 1.6, p.size * 0.6);
      } else {
        burstCtx.beginPath();
        burstCtx.arc(0, 0, p.size * 0.6, 0, Math.PI * 2);
        burstCtx.fill();
      }
      burstCtx.restore();
      return true;
    });
    burstCtx.globalAlpha = 1;
    if (particles.length) requestAnimationFrame(frame);
    else {
      running = false;
      frame.last = 0;
    }
  };
  // A burst of candy corn and sparks from the middle of an element (or a point)
  const burstAt = (target, { count = 34, colors = ['pumpkin', 'candle', 'bone'], corn = 0.45, speed = 320, top = 0.5 } = {}) => {
    if (reduced || !target) return;
    ensureCanvas();
    const r = target.getBoundingClientRect ? target.getBoundingClientRect() : { left: target.x, top: target.y, width: 0, height: 0 };
    const x = r.left + r.width / 2;
    const y = r.top + r.height * top;
    for (let i = 0; i < count; i++) {
      const a = rand(-Math.PI * 0.95, -Math.PI * 0.05);
      const v = rand(0.35, 1) * speed;
      particles.push({
        x,
        y,
        vx: Math.cos(a) * v,
        vy: Math.sin(a) * v,
        g: 700,
        life: 0,
        max: rand(0.7, 1.3),
        size: rand(4, 7),
        rot: rand(0, 6),
        spin: rand(-9, 9),
        shape: Math.random() < corn ? 'corn' : 'spark',
        color: HUES[pick(colors)]
      });
    }
    if (!running) {
      running = true;
      requestAnimationFrame(frame);
    }
  };

  /* ---------- Reveal on scroll ---------- */

  const revealer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              revealer.unobserve(entry.target);
            }),
          { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
        )
      : null;
  function initReveals(root) {
    root.querySelectorAll('[data-hw-reveal]').forEach((el) => {
      if (el.parentElement && el.parentElement.matches('[data-hw-rail-track]')) {
        el.style.setProperty('--i', Array.prototype.indexOf.call(el.parentElement.children, el) % 5);
      }
      if (revealer && !reduced) revealer.observe(el);
      else el.classList.add('is-in');
    });
  }
  const watch = (el, onChange, options) => {
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      onChange(true);
      return;
    }
    new IntersectionObserver((entries) => entries.forEach((e) => onChange(e.isIntersecting, e)), options).observe(el);
  };

  /* ---------- Rails ---------- */

  function initRail(section) {
    const track = section.querySelector('[data-hw-rail-track]');
    if (!track) return;
    const nav = section.querySelector('[data-hw-rail-nav]');
    const prev = section.querySelector('[data-hw-rail-prev]');
    const next = section.querySelector('[data-hw-rail-next]');
    const bar = section.querySelector('[data-hw-rail-bar]');
    const step = () => {
      const cell = Array.from(track.children).find((child) => child.offsetWidth > 0);
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      if (!cell) return 300;
      const w = cell.getBoundingClientRect().width + gap;
      return w * Math.max(1, Math.floor(track.clientWidth / w) - 1);
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const visible = track.clientWidth / track.scrollWidth;
      if (nav) nav.classList.toggle('is-scrollable', max > 4);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        bar.style.width = `${Math.min(100, visible * 100)}%`;
        bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * (1 / visible - 1) * 100 : 0}%)`;
      }
    };
    const behavior = reduced ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- Rooms (filled in below, one per section) ---------- */

  const INITS = { rail: initRail };

  /* ---------- Room 1: the midnight display ---------- */

  INITS.hero = (hero) => {
    hero.querySelectorAll('[data-hw-step]').forEach((el, i) => el.style.setProperty('--s', i));
    requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-lit')));

    // the offer lights up one character at a time, each with a little burst of sparks
    const chars = Array.from(hero.querySelectorAll('.hw-hero__ch'));
    const lightAll = () => chars.forEach((ch) => ch.classList.add('is-lit'));
    if (reduced) {
      lightAll();
      return;
    }
    chars.forEach((ch, i) =>
      setTimeout(() => {
        ch.classList.add('is-lit');
        burstAt(ch, { count: 12, corn: 0, speed: 200, colors: ['candle', 'pumpkin'], top: 0.45 });
      }, 900 + i * 380)
    );
    setTimeout(lightAll, 900 + chars.length * 380 + 1500);
    // lightning, now and then, while the room is on screen: the candles gutter and a ghost drifts past the bottles
    let visible = true;
    watch(hero, (v) => (visible = v));
    const flash = () => {
      hero.classList.remove('is-flash');
      void hero.offsetWidth;
      hero.classList.add('is-flash');
      setTimeout(() => hero.classList.remove('is-flash'), 1400);
    };
    const storm = (delay) =>
      setTimeout(() => {
        if (visible && !document.hidden) flash();
        storm(rand(9000, 16000));
      }, delay);
    storm(4200);
  };

  /* ---------- Room 3: the front porch ---------- */

  INITS.gifts = (section) => {
    const scene = section.querySelector('[data-hw-porch]');
    const cells = Array.from(section.querySelectorAll('[data-hw-gift-card]'));
    if (!scene) return;
    const door = scene.querySelector('.hw-door');
    let opened = false;

    // the bags tumble out of the doorway into their places
    const flyOut = () => {
      if (reduced) return;
      const d = door.getBoundingClientRect();
      const bx = d.left + d.width / 2;
      const by = d.top + d.height * 0.7;
      cells.forEach((cell, i) => {
        if (!cell.animate) return;
        const r = cell.getBoundingClientRect();
        // only the bags on screen make the trip; the rest of the row is already waiting off to the side
        if (r.left > window.innerWidth || r.top > window.innerHeight * 1.6) return;
        cell.animate(
          [
            { transform: `translate(${bx - (r.left + r.width / 2)}px, ${by - (r.top + r.height / 2)}px) scale(0.12) rotate(${i % 2 ? 30 : -30}deg)`, opacity: 0 },
            { opacity: 1, offset: 0.25 },
            { transform: 'translateY(-14px)', offset: 0.82 },
            { transform: 'none', opacity: 1 }
          ],
          { duration: 1100, delay: 500 + i * 110, easing: 'cubic-bezier(.2,.8,.3,1)', fill: 'backwards' }
        );
      });
    };
    const open = () => {
      if (opened) return;
      opened = true;
      scene.classList.add('is-open');
      if (reduced) return;
      setTimeout(() => burstAt(door, { count: 46, speed: 420, top: 0.75 }), 700);
      flyOut();
    };
    if (reduced) {
      open();
      return;
    }
    // the door opens by itself as the porch comes into view
    watch(scene, (visible) => visible && open(), { threshold: 0.45 });
  };

  /* ---------- Room 4: the potion lab (gift finder): three questions, one at a time ---------- */

  INITS.finder = (section) => {
    const grid = section.querySelector('[data-hw-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-hw-card]'));
    const quiz = section.querySelector('[data-hw-quiz]');
    if (!cards.length || !quiz) return;
    const panels = Array.from(quiz.querySelectorAll('[data-hw-panel]'));
    const dots = Array.from(quiz.querySelectorAll('[data-hw-progress]'));
    const choices = Array.from(quiz.querySelectorAll('[data-hw-choice]'));
    const back = quiz.querySelector('[data-hw-back]');
    const skip = quiz.querySelector('[data-hw-skip]');
    const flask = section.querySelector('[data-hw-flask]');
    const flaskCount = section.querySelector('[data-hw-flask-count]');
    const results = section.querySelector('[data-hw-results]');
    const rail = section.querySelector('[data-hw-finder-rail]');
    const summary = section.querySelector('[data-hw-count]');
    const empty = section.querySelector('[data-hw-empty]');
    const sortSelect = section.querySelector('[data-hw-sort]');
    initRail(section);

    // The answers: null until chosen. "all" / "any" mean no limit.
    const answer = { who: null, vibe: null, budget: null };
    const order = ['who', 'vibe', 'budget'];
    let step = 1;
    let done = false;
    let sort = 'featured';

    const choiceFor = (key) => choices.find((c) => c.dataset.hwChoice === key && c.dataset.value === answer[key]) || null;
    const fits = (card, key, value) => {
      if (value == null || value === 'all' || value === 'any') return true;
      if (key === 'who') return (card.dataset.for || '').split(' ').includes(value);
      if (key === 'vibe') return (card.dataset.vibes || '').split(' ').includes(value);
      const band = choices.find((c) => c.dataset.hwChoice === 'budget' && c.dataset.value === value);
      const price = Number(card.dataset.price);
      const min = Number(band.dataset.min || 0);
      const max = band.dataset.max ? Number(band.dataset.max) : Infinity;
      return price >= min && price < max;
    };
    // every card that fits the answers so far, with one answer swapped for a value being tried
    const matching = (tryKey, tryValue) =>
      cards.filter((card) => order.every((key) => fits(card, key, key === tryKey ? tryValue : answer[key])));

    // each choice shows how many fragrances it would find, given the answers before it; none means disabled
    const paintCounts = () => {
      choices.forEach((choice) => {
        const key = choice.dataset.hwChoice;
        const index = order.indexOf(key);
        const n = cards.filter((card) =>
          order.every((k, i) => (k === key ? fits(card, k, choice.dataset.value) : i < index ? fits(card, k, answer[k]) : true))
        ).length;
        const label = choice.querySelector('[data-hw-n]');
        if (label) label.textContent = `${n} ${n === 1 ? 'fragrance' : 'fragrances'}`;
        choice.disabled = n === 0;
        choice.setAttribute('aria-pressed', String(answer[key] === choice.dataset.value));
      });
    };

    const show = (n) => {
      step = n;
      panels.forEach((panel) => {
        const on = Number(panel.dataset.hwPanel) === n;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
      dots.forEach((dot) => {
        const i = Number(dot.dataset.hwProgress);
        dot.classList.toggle('is-current', i === n);
        dot.classList.toggle('is-done', answer[order[i - 1]] != null && i !== n);
        // a step can be revisited once everything before it is answered
        dot.querySelector('button').disabled = !order.slice(0, i - 1).every((k) => answer[k] != null);
      });
      if (back) back.hidden = n === 1;
      paintCounts();
    };

    const pour = () => {
      if (!flask) return;
      const chosen = choiceFor('vibe');
      flask.style.setProperty('--brew', (chosen && chosen.dataset.color) || '#ff7a1f');
      flask.classList.remove('is-pouring');
      void flask.offsetWidth;
      flask.classList.add('is-pouring');
    };

    const renderResults = (animate = true) => {
      const matched = matching();
      const featured = (a, b) => b.dataset.best - a.dataset.best || a.dataset.index - b.dataset.index;
      const byPrice = (a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (sort === 'low' ? 1 : -1);
      matched.sort(sort === 'featured' ? featured : byPrice);
      const fragment = document.createDocumentFragment();
      matched.concat(cards.filter((card) => !matched.includes(card))).forEach((card) => fragment.appendChild(card));
      grid.appendChild(fragment);
      cards.forEach((card) => {
        card.hidden = !matched.includes(card);
        card.classList.remove('is-entering');
      });
      if (animate && !reduced) {
        matched.slice(0, 12).forEach((card, k) => {
          card.style.setProperty('--k', k);
          void card.offsetWidth;
          card.classList.add('is-entering');
        });
      }
      if (flaskCount) flaskCount.textContent = matched.length;
      // "12 matches ✦ For her ✦ Sweet ✦ Under $15"
      const parts = [`<b>${matched.length}</b> ${matched.length === 1 ? 'match' : 'matches'}`];
      order.forEach((key) => {
        const chosen = choiceFor(key);
        if (chosen && chosen.dataset.phrase) parts.push(`<span>${chosen.dataset.phrase}</span>`);
      });
      summary.innerHTML = parts.join('<i aria-hidden="true">✦</i>');
      empty.hidden = matched.length > 0;
      rail.hidden = matched.length === 0;
      grid.scrollLeft = 0;
      grid.dispatchEvent(new Event('scroll'));
    };

    const finish = () => {
      done = true;
      dots.forEach((dot) => dot.classList.remove('is-current'));
      results.hidden = false;
      results.classList.remove('is-shown');
      void results.offsetWidth;
      results.classList.add('is-shown');
      renderResults();
      results.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    };

    choices.forEach((choice) =>
      choice.addEventListener('click', () => {
        const key = choice.dataset.hwChoice;
        answer[key] = choice.dataset.value;
        // a later answer that no longer fits is cleared
        order.slice(order.indexOf(key) + 1).forEach((k) => {
          const kept = choiceFor(k);
          if (kept && !matching().length) answer[k] = null;
        });
        if (key === 'vibe') {
          pour();
          burstAt(choice.querySelector('.hw-potion__bottle'), { count: 14, corn: 0, speed: 180, colors: ['slime', 'bone'], top: 0.2 });
        }
        paintCounts();
        if (flaskCount) flaskCount.textContent = matching().length;
        // once the matches are showing, they follow every change straight away
        if (!results.hidden) renderResults(false);
        if (done) return;
        const next = order.indexOf(key) + 2;
        setTimeout(() => (next <= 3 ? show(next) : finish()), reduced ? 0 : 380);
      })
    );
    if (back) back.addEventListener('click', () => step > 1 && show(step - 1));
    dots.forEach((dot) => dot.querySelector('button').addEventListener('click', () => show(Number(dot.dataset.hwProgress))));
    if (skip) {
      skip.addEventListener('click', () => {
        order.forEach((key) => answer[key] == null && (answer[key] = key === 'budget' ? 'any' : 'all'));
        show(3);
        finish();
      });
    }

    const restart = () => {
      answer.who = answer.vibe = answer.budget = null;
      done = false;
      results.hidden = true;
      rail.hidden = true;
      empty.hidden = true;
      sort = 'featured';
      if (sortSelect) sortSelect.value = 'featured';
      pour();
      if (flaskCount) flaskCount.textContent = cards.length;
      show(1);
      quiz.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    };
    const change = section.querySelector('[data-hw-change]');
    if (change) {
      change.addEventListener('click', () => {
        // walk through the questions again; the matches below keep up as answers change
        done = false;
        show(1);
        quiz.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }
    section.querySelectorAll('[data-hw-restart], [data-hw-reset]').forEach((button) => button.addEventListener('click', restart));
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        sort = sortSelect.value;
        renderResults();
      });
    }

    if (flaskCount) flaskCount.textContent = cards.length;
    show(1);
  };

  /* ---------- The last room: lights out ---------- */

  INITS.finale = (section) => {
    if (reduced) return;
    const eyes = Array.from(section.querySelectorAll('[data-hw-eye]'));
    const hint = section.querySelector('[data-hw-dark-hint]');
    let x = 0.5;
    let y = 0.4;
    let tx = x;
    let ty = y;
    let lastInput = 0;
    let t = 0;
    let visible = false;
    let running = false;
    let last = 0;

    const aim = (clientX, clientY) => {
      const r = section.getBoundingClientRect();
      tx = (clientX - r.left) / r.width;
      ty = (clientY - r.top) / r.height;
      lastInput = performance.now();
      if (hint) hint.classList.add('is-gone');
    };
    section.addEventListener('pointermove', (e) => aim(e.clientX, e.clientY));
    section.addEventListener('touchstart', (e) => e.touches[0] && aim(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    section.addEventListener('touchmove', (e) => e.touches[0] && aim(e.touches[0].clientX, e.touches[0].clientY), { passive: true });

    // an eye caught in the beam blinks out, then turns up somewhere else in the dark
    const scurry = (eye) => {
      eye.classList.add('is-caught');
      setTimeout(() => {
        eye.style.setProperty('--x', `${rand(4, 90).toFixed(1)}%`);
        eye.style.setProperty('--y', `${rand(6, 90).toFixed(1)}%`);
        eye.classList.remove('is-caught');
      }, 1600);
    };

    const frame = (now) => {
      if (!visible) {
        running = false;
        return;
      }
      const dt = Math.min(0.05, (now - (last || now)) / 1000);
      last = now;
      // left alone, the light sweeps the room slowly
      if (now - lastInput > 2600) {
        t += dt;
        tx = 0.5 + Math.sin(t * 0.55) * 0.38;
        ty = 0.45 + Math.sin(t * 0.9 + 1.2) * 0.32;
      }
      x += (tx - x) * Math.min(1, dt * 7);
      y += (ty - y) * Math.min(1, dt * 7);
      section.style.setProperty('--mx', `${(x * 100).toFixed(2)}%`);
      section.style.setProperty('--my', `${(y * 100).toFixed(2)}%`);
      const r = section.getBoundingClientRect();
      const beam = parseFloat(getComputedStyle(section).getPropertyValue('--beam')) || 200;
      eyes.forEach((eye) => {
        if (eye.classList.contains('is-caught')) return;
        const e = eye.getBoundingClientRect();
        const d = Math.hypot(e.left + e.width / 2 - (r.left + x * r.width), e.top + e.height / 2 - (r.top + y * r.height));
        if (d < beam * 0.55) scurry(eye);
      });
      requestAnimationFrame(frame);
    };
    watch(section, (v) => {
      visible = v;
      if (v && !running) {
        running = true;
        last = 0;
        requestAnimationFrame(frame);
      }
    });
  };

  /* ROOMS */

  /* ---------- Sticky bar ---------- */

  INITS.sticky = (bar) => {
    const hide = new Set();
    const zones = [document.querySelector('.hw-hero'), document.querySelector('.hw-finale'), document.querySelector('footer, .footer, [id*="__footer"]')].filter(Boolean);
    let seenHero = !document.querySelector('.hw-hero');
    const update = () => bar.classList.toggle('is-shown', seenHero && hide.size === 0);
    zones.forEach((zone) =>
      watch(
        zone,
        (isVisible, entry) => {
          const inView = isVisible && (!entry || entry.intersectionRatio >= 0.2 || entry.intersectionRect.height > window.innerHeight * 0.35);
          if (inView) hide.add(zone);
          else {
            hide.delete(zone);
            if (zone.classList.contains('hw-hero')) seenHero = true;
          }
          update();
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.5] }
      )
    );
  };

  /* ---------- Add to cart: candy corn on tap, "Added ✓" once the cart has it ---------- */

  let lastAddButton = null;
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form.closest || !form.closest('.hw-card')) return;
      lastAddButton = form.querySelector('.hw-btn--add');
      burstAt(lastAddButton, { count: 26, speed: 260 });
    },
    true
  );
  document.addEventListener('product-ajax:added', () => {
    const button = lastAddButton;
    if (!button) return;
    button.classList.add('is-added');
    setTimeout(() => button.classList.remove('is-added'), 1800);
  });

  /* ---------- Transparent header: the hero slides up underneath it ---------- */

  function initHeaderOver() {
    const hero = document.querySelector('main > .shopify-section:first-child .hw-hero');
    const header = document.querySelector('header.header');
    const section = header && header.closest('.shopify-section');
    if (!hero || !section || header.getAttribute('is') === 'sticky-header') return;
    const measure = () => html.style.setProperty('--hw-header-h', `${Math.round(section.offsetHeight)}px`);
    measure();
    document.body.classList.add('hw-header-over');
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(section);
  }

  /* ---------- Boot (and re-boot sections changed in the theme editor) ---------- */

  function boot(root) {
    root.querySelectorAll('[data-hw-section]').forEach((section) => {
      const init = INITS[section.dataset.hwSection];
      if (init) init(section);
    });
    initReveals(root);
    tickCountdowns();
  }
  const start = () => {
    initHeaderOver();
    boot(document);
    setInterval(tickCountdowns, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
